import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DocumentUpload } from 'src/app/shared/models/document-upload.model';
import {
  ComposeEmail,
  OpenedClosedActivitiesCount,
} from '../models/leads.model';

@Injectable({
  providedIn: 'root',
})
export class LeadsSharedService {
  private subjectLeadtDocAttachmentList = new BehaviorSubject(null);
  private subjectOpenTaskAddModal = new BehaviorSubject(null);
  private subjectOpenMeetingAddModal = new BehaviorSubject(null);
  private subjectOpenCallsAddModal = new BehaviorSubject(null);
  private subjectOpenTaskTableChange = new BehaviorSubject(null);
  private subjectOpenMeetingTableChange = new BehaviorSubject(null);
  private subjectOpenComposeEmailAddModal = new BehaviorSubject(null);
  private subjectEmailTableChanged = new BehaviorSubject(null);
  private subjectDraftTableChanged = new BehaviorSubject(null);
  private subjectScheduledTableChanged = new BehaviorSubject(null);
  private subjectOpenComposeEmailEditModal = new BehaviorSubject(null);
  private subjectOpenScheduleModal = new BehaviorSubject(null);
  private subjectNumberOfMail = new BehaviorSubject(null);
  private subjectNumberOfDraftMail = new BehaviorSubject(null);
  private subjectNumberOfScheduleMail = new BehaviorSubject(null);
  private subjectCurrentLeadMail = new BehaviorSubject(null);
  private subjectCallLogTableChange = new BehaviorSubject(null);
  private subjectLeadImportModal = new BehaviorSubject(null);
  private subjectLeadListTableChanged = new BehaviorSubject(null);
  private subjectRemoveEmailDraftModal = new BehaviorSubject(null);
  private subjectOpenCampaignListModal = new BehaviorSubject(null);
  private subjectNumberOfCanceledMails = new BehaviorSubject(null);
  private subjectCancelEmailTableChanged = new BehaviorSubject(null);
  private subjectQuickCreateCampaignModal = new BehaviorSubject(null);
  private subjectAssignCampaginToLeadModal = new BehaviorSubject(null);
  private subjectChooseCampaignTableChanged = new BehaviorSubject(null);
  private subjectAssignCampaignTableChanged = new BehaviorSubject(null);
  private subjectConvertLeadCampaignSourceId = new BehaviorSubject(null);
  private subjectOpenedClosedActivitiesCount = new BehaviorSubject(null);
  private subjectNumberOfAssignCampaignToLead = new BehaviorSubject(null);
  private subjectLeadKanbanData = new BehaviorSubject(null);

  constructor() {}

  setsubjectLeadDocAttachmentList(attachmentArray: DocumentUpload[]) {
    this.subjectLeadtDocAttachmentList.next(attachmentArray);
  }

  getsubjectLeadDocAttachmentList(): Observable<DocumentUpload[]> {
    return this.subjectLeadtDocAttachmentList.asObservable();
  }

  //Lead View - open ativities - Task
  setsubjectOpenTaskAddModal(string: string) {
    this.subjectOpenTaskAddModal.next(string);
  }
  getsubjectOpenTaskAddModal(): Observable<any> {
    return this.subjectOpenTaskAddModal.asObservable();
  }

  //Lead View - open ativities - Meeting
  setsubjectOpenMeetingAddModal(string: string) {
    this.subjectOpenMeetingAddModal.next(string);
  }
  getsubjectOpenMeetingAddModal(): Observable<any> {
    return this.subjectOpenMeetingAddModal.asObservable();
  }

  //Lead View - open ativities - Calls
  setsubjectOpenMeetingCallsModal(obj: any) {
    this.subjectOpenCallsAddModal.next(obj);
  }
  getsubjectOpenMeetingCallsModal(): Observable<string> {
    return this.subjectOpenCallsAddModal.asObservable();
  }

  // Lead Open Activity List view
  getsubjectOpenTaskTableChange(): Observable<any> {
    return this.subjectOpenTaskTableChange.asObservable();
  }
  setsubjectOpenTaskTableChange(flag: boolean) {
    this.subjectOpenTaskTableChange.next(flag);
  }

  // Lead Open Activity Meeting List view
  getsubjectOpenMeetingTableChange(): Observable<any> {
    return this.subjectOpenMeetingTableChange.asObservable();
  }
  setsubjectOpenMeetingTableChange(flag: boolean) {
    this.subjectOpenMeetingTableChange.next(flag);
  }

  //Lead Compose Email
  setsubjectOpenComposeEmailAddModal(string: string) {
    this.subjectOpenComposeEmailAddModal.next(string);
  }

  getsubjectOpenComposeEmailAddModal(): Observable<any> {
    return this.subjectOpenComposeEmailAddModal.asObservable();
  }

  setSubjectEmailTableChanged(flag: boolean) {
    return this.subjectEmailTableChanged.next(flag);
  }

  getSubjectEmailTableChanged(): Observable<any> {
    return this.subjectEmailTableChanged.asObservable();
  }

  setSubjectDraftTableChanged(flag: boolean) {
    return this.subjectDraftTableChanged.next(flag);
  }

  getSubjectDraftTableChanged(): Observable<any> {
    return this.subjectDraftTableChanged.asObservable();
  }

  setsubjectOpenComposeEmailEditModal(string: string) {
    this.subjectOpenComposeEmailEditModal.next(string);
  }

  getsubjectOpenComposeEmailEditModal(): Observable<any> {
    return this.subjectOpenComposeEmailEditModal.asObservable();
  }

  setSubjectOpenScheduleModal(obj: ComposeEmail) {
    this.subjectOpenScheduleModal.next(obj);
  }

  getSubjectOpenScheduleModal(): Observable<any> {
    return this.subjectOpenScheduleModal.asObservable();
  }

  setSubjectScheduledTableChanged(flag: boolean) {
    return this.subjectScheduledTableChanged.next(flag);
  }

  getSubjectScheduledTableChanged(): Observable<any> {
    return this.subjectScheduledTableChanged.asObservable();
  }

  setSubjectNumberOfMails(number: number) {
    return this.subjectNumberOfMail.next(number);
  }

  getSubjectNumberOfMails(): Observable<any> {
    return this.subjectNumberOfMail.asObservable();
  }

  setSubjectNumberOfDraftMails(number: number) {
    return this.subjectNumberOfDraftMail.next(number);
  }

  getSubjectNumberOfDraftMails(): Observable<any> {
    return this.subjectNumberOfDraftMail.asObservable();
  }

  setSubjectNumberOfScheduleMails(number: number) {
    return this.subjectNumberOfScheduleMail.next(number);
  }

  getSubjectNumberOfScheduleMails(): Observable<any> {
    return this.subjectNumberOfScheduleMail.asObservable();
  }

  setSubjectCurrentLeadMail(mail: string) {
    return this.subjectCurrentLeadMail.next(mail);
  }

  getSubjectCurrentLeadMail(): Observable<any> {
    return this.subjectCurrentLeadMail.asObservable();
  }

  //lead call log
  setSubjectCallLogTableChange(flag: boolean) {
    return this.subjectCallLogTableChange.next(flag);
  }

  getSubjectCallLogTableChange(): Observable<boolean> {
    return this.subjectCallLogTableChange.asObservable();
  }

  setSubjectOpenCampaignListModal(str: string) {
    return this.subjectOpenCampaignListModal.next(str);
  }

  getSubjectOpenCampaignListModal(): Observable<any> {
    return this.subjectOpenCampaignListModal.asObservable();
  }

  setSubjectConvertLeadCampaignSourceId(str: string) {
    return this.subjectConvertLeadCampaignSourceId.next(str);
  }

  getSubjectConvertLeadCampaignSourceId(): Observable<any> {
    return this.subjectConvertLeadCampaignSourceId.asObservable();
  }

  setSubjectQuickCreateCampaignModal(str: string) {
    return this.subjectQuickCreateCampaignModal.next(str);
  }

  getSubjectQuickCreateCampaignModal(): Observable<any> {
    return this.subjectQuickCreateCampaignModal.asObservable();
  }

  setSubjectChooseCampaignTableChanged(flag: boolean) {
    return this.subjectChooseCampaignTableChanged.next(flag);
  }

  getSubjectChooseCampaignTableChanged(): Observable<any> {
    return this.subjectChooseCampaignTableChanged.asObservable();
  }

  setSubjectLeadImportModal(str: string) {
    this.subjectLeadImportModal.next(str);
  }
  getSubjectLeadImportModal(): Observable<any> {
    return this.subjectLeadImportModal.asObservable();
  }

  setSubjectLeadListTableChanged(flag: boolean) {
    this.subjectLeadListTableChanged.next(flag);
  }
  getSubjectLeadListTableChanged(): Observable<any> {
    return this.subjectLeadListTableChanged.asObservable();
  }
  setSubjectRemoveEmailDraftModal(flag: boolean) {
    this.subjectRemoveEmailDraftModal.next(flag);
  }
  getSubjectRemoveEmailDraftModal(): Observable<any> {
    return this.subjectRemoveEmailDraftModal.asObservable();
  }

  setSubjectAssignCampaginToLeadModal(str: string) {
    this.subjectAssignCampaginToLeadModal.next(str);
  }
  getSubjectAssignCampaginToLeadModal(): Observable<any> {
    return this.subjectAssignCampaginToLeadModal.asObservable();
  }

  setSubjectAssignCampaignTableChanged(flag: boolean) {
    this.subjectAssignCampaignTableChanged.next(flag);
  }
  getSubjectAssignCampaignTableChanged(): Observable<any> {
    return this.subjectAssignCampaignTableChanged.asObservable();
  }

  setSubjectNumberOfAssignCampaignToLead(num: number) {
    this.subjectNumberOfAssignCampaignToLead.next(num);
  }
  getSubjectNumberOfAssignCampaignToLead(): Observable<any> {
    return this.subjectNumberOfAssignCampaignToLead.asObservable();
  }

  setSubjectNumberOfCanceledMails(num: number) {
    this.subjectNumberOfCanceledMails.next(num);
  }
  getSubjectNumberOfCanceledMails(): Observable<any> {
    return this.subjectNumberOfCanceledMails.asObservable();
  }

  setSubjectCancelEmailTableChanged(falg: boolean) {
    this.subjectCancelEmailTableChanged.next(falg);
  }
  getSubjectCancelEmailTableChanged(): Observable<any> {
    return this.subjectCancelEmailTableChanged.asObservable();
  }

  // Opened Closed Activities Count
  setSubjectOpendClosedActivitiesCountChanged(
    count: OpenedClosedActivitiesCount
  ) {
    this.subjectOpenedClosedActivitiesCount.next(count);
  }

  getSubjectOpendClosedActivitiesCountChanged(): Observable<any> {
    return this.subjectOpenedClosedActivitiesCount.asObservable();
  }

  setSubjectLeadKanbanData(inquiryData: any) {
    this.subjectLeadKanbanData.next(inquiryData);
  }
  getSubjectLeadKanbanData(): Observable<any> {
    return this.subjectLeadKanbanData.asObservable();
  }
}
